var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cloud",
    id: "cloud",
    d: "M16.5917 40.9556C9.6375 40.9556 4 35.3181 4 28.3639C4 21.4097 9.6375 15.7722 16.5917 15.7722C18.0996 15.7722 19.5456 16.0372 20.8856 16.5233C23.5295 10.0564 29.8835 5.5 37.3018 5.5C47.0926 5.5 55.0296 13.437 55.0296 23.2278C55.0296 23.6591 55.0142 24.0868 54.9839 24.5104C57.9447 25.8737 60 28.8669 60 32.3402C60 37.0984 56.1428 40.9556 51.3846 40.9556H16.5917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M46.4771 47.8547L44.7574 44.2692L43.0376 47.8548C42.8669 48.1536 42.7692 48.5009 42.7692 48.8715C42.7692 49.9898 43.6593 50.8964 44.7574 50.8964C45.8554 50.8964 46.7455 49.9898 46.7455 48.8715C46.7455 48.5009 46.6478 48.1535 46.4771 47.8547Z",
    fill: "#64D2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M40.5127 55.1448L38.7929 51.5592L37.0732 55.1445C36.9025 55.4433 36.8047 55.7907 36.8047 56.1614C36.8047 57.2798 37.6948 58.1864 38.7929 58.1864C39.8909 58.1864 40.781 57.2798 40.781 56.1614C40.781 55.7909 40.6833 55.4436 40.5127 55.1448Z",
    fill: "#64D2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M34.5482 47.8548L32.8284 44.2692L31.1086 47.8547C30.938 48.1535 30.8402 48.5009 30.8402 48.8715C30.8402 49.9898 31.7303 50.8964 32.8284 50.8964C33.9264 50.8964 34.8165 49.9898 34.8165 48.8715C34.8165 48.5009 34.7188 48.1536 34.5482 47.8548Z",
    fill: "#64D2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M28.9149 55.1445L27.1952 51.5592L25.4754 55.1447C25.3048 55.4435 25.2071 55.7908 25.2071 56.1614C25.2071 57.2798 26.0972 58.1864 27.1952 58.1864C28.2933 58.1864 29.1834 57.2798 29.1834 56.1614C29.1834 55.7908 29.0856 55.4434 28.9149 55.1445Z",
    fill: "#64D2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M22.9506 47.8549L21.2308 44.2692L19.511 47.8546C19.3403 48.1534 19.2426 48.5008 19.2426 48.8715C19.2426 49.9898 20.1327 50.8964 21.2307 50.8964C22.3288 50.8964 23.2189 49.9898 23.2189 48.8715C23.2189 48.5009 23.1212 48.1536 22.9506 47.8549Z",
    fill: "#64D2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M16.986 55.1446L15.2662 51.5592L13.5465 55.1446C13.3758 55.4434 13.2781 55.7908 13.2781 56.1614C13.2781 57.2798 14.1682 58.1864 15.2662 58.1864C16.3643 58.1864 17.2544 57.2798 17.2544 56.1614C17.2544 55.7908 17.1567 55.4434 16.986 55.1446Z",
    fill: "#64D2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy);
export default __webpack_public_path__ + "static/media/rainy.3cb2e9cd6d1f18f655560ea53bee991d.svg";
export { ForwardRef as ReactComponent };